import Vue from 'vue'

export const notificationMixin = {
  methods: {
    sendNotification: function (notification, type) {
      if (this.notifications) {
        Vue.set(this.notifications, notification, type)
      }
    },
    resetNotification: function (notification) {
      if (this.notifications) {
        Vue.set(this.notifications, notification, null)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/notification.js